// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__j6Cui","labelContainer":"select_labelContainer__UXKeg","icon":"select_icon__2_skD"};